export default "__VITE_ASSET__BeIMFGOl__"